import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import styles from './Navigation.module.css'

const navigationItems = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'services', label: 'Services' },
  { id: 'experience', label: 'Experience' },
  { id: 'projects', label: 'Work' },
]

const Navigation = ({ className = '' }) => {
  const [activeSection, setActiveSection] = useState('home')
  const location = useLocation()

  useEffect(() => {
    if (location.pathname !== '/') return

    const handleScroll = () => {
      const sections = navigationItems.map(item => ({
        id: item.id,
        element: document.getElementById(item.id)
      })).filter(section => section.element)

      // Find the section closest to the top of the viewport
      let closest = null
      let closestDistance = Infinity

      for (const section of sections) {
        const rect = section.element.getBoundingClientRect()
        const distance = Math.abs(rect.top - 100)

        if (distance < closestDistance) {
          closestDistance = distance
          closest = section.id
        }
      }

      if (closest) {
        setActiveSection(closest)
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => window.removeEventListener('scroll', handleScroll)
  }, [location])

  const handleClick = (e, sectionId) => {
    e.preventDefault()

    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`
      return
    }

    // For HOME, scroll to top
    if (sectionId === 'home') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      return
    }

    const element = document.getElementById(sectionId)
    if (element) {
      const headerOffset = 80
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }

  return (
    <nav className={`${styles.navigation} ${className}`}>
      <ul className={styles.navList}>
        {navigationItems.map(item => (
          <li key={item.id} className={styles.navItem}>
            <a
              href={`#${item.id}`}
              onClick={(e) => handleClick(e, item.id)}
              className={`${styles.navLink} ${
                location.pathname === '/' && activeSection === item.id ? styles.active : ''
              }`}
            >
              {item.label}
            </a>
          </li>
        ))}
        <li className={styles.navItem}>
            <a
                href="https://calendly.com/inonbaguio/30min"
                className={styles.ctaButton}
                target="_blank"
                rel="noopener noreferrer"
            >
                Book a call
            </a>
        </li>
      </ul>
    </nav>
  )
}

export default Navigation
